import logo from '../assets/images/logo.png';

/**
 * The Nannies to the Rescue logo, shown in the site header/footer, the portal
 * sidebar and the auth pages. Drop a new file at src/assets/images/logo.png to
 * change it everywhere. Keeps the .brand-mark class so existing size/spacing
 * rules still apply; .brand-mark-logo clears the placeholder background.
 */
export default function BrandMark({ className = '' }) {
  return (
    <img
      src={logo}
      alt="Nannies to the Rescue"
      className={`brand-mark brand-mark-logo ${className}`.trim()}
    />
  );
}
